;(function () {
  'use strict'

  angular.module('contrast.filtering').constant('QUICK_FILTERS', {
    APPS: {
      ALL: { KEY: 'ALL', VALUE: 'All' },
      ONLINE: { KEY: 'ONLINE', VALUE: 'Online' },
      OFFLINE: { KEY: 'OFFLINE', VALUE: 'Offline' },
      MERGED: { KEY: 'MERGED', VALUE: 'Merged' },
      LICENSED: { KEY: 'LICENSED', VALUE: 'Licensed' },
      UNLICENSED: { KEY: 'UNLICENSED', VALUE: 'Unlicensed' },
      HIGH_RISK: { KEY: 'HIGH_RISK', VALUE: 'High Risk' },
      INCOMPLETE_PROTECTION: {
        KEY: 'INCOMPLETE_PROTECTION',
        VALUE: 'Incomplete Protection'
      },
      VIOLATION: { KEY: 'VIOLATION', VALUE: 'Policy Violation' }
    },
    SERVERS: {
      ALL: { KEY: 'ALL', VALUE: 'All', translationId: 'title_all_servers' },
      PROTECTED: {
        KEY: 'PROTECTED',
        VALUE: 'Protected',
        translationId: 'details_seeprotectedServers'
      },
      UNPROTECTED: {
        KEY: 'UNPROTECTED',
        VALUE: 'Unprotected',
        translationId: 'details_seeunprotectedServers'
      },
      ONLINE: {
        KEY: 'ONLINE',
        VALUE: 'Online',
        translationId: 'details_seeonlineServers'
      },
      OFFLINE: {
        KEY: 'OFFLINE',
        VALUE: 'Offline',
        translationId: 'details_seeofflineServers'
      },
      OUT_OF_DATE: {
        KEY: 'OUT_OF_DATE',
        VALUE: 'Out of Date',
        translationId: 'details_seeoutOfDateServers'
      }
    },
    ATTACK_EVENTS: {
      ALL: { KEY: 'ALL', VALUE: 'All' },
      PRODUCTION: { KEY: 'PRODUCTION', VALUE: 'Production' },
      ACTIVE_ATTACK: { KEY: 'ACTIVE_ATTACK', VALUE: 'Active' },
      MANUAL: { KEY: 'MANUAL', VALUE: 'Manual' },
      AUTOMATED: { KEY: 'AUTOMATED', VALUE: 'Automated' }
    },
    VULNS: {
      ALL: { KEY: 'ALL', VALUE: 'All' },
      OPEN: { KEY: 'OPEN', VALUE: 'Open' },
      HIGH_CONFIDENCE: { KEY: 'HIGH_CONFIDENCE', VALUE: 'High Confidence' },
      VIOLATION: { KEY: 'VIOLATION', VALUE: 'Policy Violation' }
    }
  })
})()
